export default "__VITE_ASSET__3ad959b5__"